export const CLIENT_BACKGROUND_TABS = {
  VIEW_PROFILE: "VIEW_PROFILE",
  EDIT_PROFILE: "EDIT_PROFILE",
  UPLOAD_STATEMENT: "UPLOAD_STATEMENT",
  VIEW_PAST_PERFORMANCE: "VIEW_PAST_PERFORMANCE",
  SWOT_VIEW: "SWOT_VIEW",
};

export const PRODUCTS_TABS = {
  CATEGORY_SIZE: "CATEGORY_SIZE",
  INSIGHTS_RESEARCH: "INSIGHTS_RESEARCH",
  SME_ACTIVITY: "SME_ACTIVITY",
  FIND_EXPERTS: "FIND_EXPERTS",
  FIND_SUPPLIERS: "FIND_SUPPLIERS"
};

export const USER_PROFILE_TABS = {
  MY_PROFILE: "MY_PROFILE",
  PAYMENTS: "PAYMENTS",
  MY_REFERALS: "MY_REFERALS"
};